import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { _ListGallery } from "../../models/fieldSettings";
import { DB_POSTFIX, getFileLiveUrl, upperCase } from "../../utils";
import LoaderIcon from "../../utils/LoaderIcon";
import ImageGallery from "react-image-gallery";
import { Image } from "antd";
import { Link } from "react-router-dom";
import "react-image-gallery/styles/css/image-gallery.css";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import PsContext from "../../context";

const GallerySingle = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    axios
      .get(
        ServiceUrl.LIST_GALLERY +
          "?sadb=" +
          DB_POSTFIX +
          "&all=1" +
          "&category=" +
          props.match.params.galleryId
      )
      .then((res) => {
        console.log("res", res["data"].data);

        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          setLoader(false);
        }
      });
  };

  const field = (fieldName) => dataList?.[0]?.[fieldName] || "";

  const getImages = () => {
    let rv = [];
    dataList.map((item, i) => {
      rv.push({
        original: getFileLiveUrl(item.feature_image),
        thumbnail: getFileLiveUrl(item.feature_image),
      });
    });
    return rv;
  };

  return (
    <>
      {/* <section>
        <div className="head-2">
          <div className="container">
            <div className="head-2-inn head-2-inn-padd-top">
              <h1>{field("title")}</h1>
            </div>
          </div>
        </div>
      </section> */}

      <section>
        <div className="container com-sp pad-bot-70 pg-inn ps_min_height px-5">
          <Row>
            <Col md={8}>
              <h5
                style={{
                  color: `${context.settingValue("web_site_header_textcolor")}`,
                }}
              >
                {upperCase(field("title"))}
              </h5>
            </Col>
            <Col md={4} className="text-end">
              <Link to="/gallery" className="text-black fw-bold">
                <i class="fa-solid fa-arrow-left me-2"></i>Back to list
              </Link>
            </Col>

            <hr />
            {loader && <LoaderIcon />}

            {/* Slider */}

            {context.settingValue("web_site_single_gallery_viewtype") ==
              "slider" &&
              dataList &&
              dataList.length > 0 && (
                <Col md={12}>
                  <ImageGallery items={getImages()} />;
                </Col>
              )}

            {/* Slider */}

            {/* Card */}

            {context.settingValue("web_site_single_gallery_viewtype") ==
              "card" &&
              dataList &&
              dataList.map((item, index) => (
                <Col md={3} key={index} className="mt-2">
                  <div className="card">
                    <Image
                      className="w-100 rounded"
                      height="200px"
                      src={getFileLiveUrl(item.feature_image)}
                    />
                  </div>
                </Col>
              ))}

            {/* Card */}
          </Row>
        </div>
      </section>
    </>
  );
};

export default GallerySingle;
